import { EventSourceHandler } from '@sellsy/sse';

export default class ConformityPdfGeneratedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'corporation.conformity.pdf.generated';
    }

    handle(event) {
        window.EventBus.emit('conformity:generate', event.data);
    }
}
